import {css} from '@emotion/css';
import {useMemo} from 'react';

import {useWolfTheme} from '../../contexts';

const useStyles = () => {
    const theme = useWolfTheme();

    return useMemo(
        () => ({
            button: css({
                padding: `6px !important`,
                border: 'none !important',
                height: 'auto !important',
                color: `${theme.palette.foreground.default} !important`,

                '& svg': {
                    fill: theme.palette.foreground.default,
                },
                '&:hover, &:active': {
                    backgroundColor: `${theme.palette.neutral.background} !important`,
                },
            }),
        }),
        [theme]
    );
};

export default useStyles;
